import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TNavigationReduxState } from '~types/redux/state';
import { NavigationTabsEnum } from '~utils/enums';

const initialState: TNavigationReduxState = {
    currentTab: NavigationTabsEnum.Dashboard,
};

const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        navigationSetCurrentTab: (state, action: PayloadAction<NavigationTabsEnum>) => {
            state.currentTab = action.payload;
        },
    },
});

export default {
    actions: navigationSlice.actions,
    reducers: navigationSlice.reducer,
};
